import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../firebase'
import AddPlayerSquadSeasonListTemplate from './AddPlayerSquadSeasonListTemplate'

export default function AddPlayerSquadSeason({teamId, season, squad}) {

    const [players, setPlayers] = useState([])
    // Fetch from FB In case filtered squad from props is wrong
    const [squadFB, setSquadFB] = useState([])

    useEffect(() => {

        try {
            const teamPlayersRef = firestore.collection("teams").doc(teamId).collection("players")
            teamPlayersRef.onSnapshot(({docs}) => {
                const players = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setPlayers(players)
            })
        } catch (error) {
            
        }

    }, [])


    useEffect(() => {
        try {
            const teamSquadBySeasonRef = firestore.collection("teams").doc(teamId).collection("team-squads")
            teamSquadBySeasonRef.where("season", "==", +season).onSnapshot(({docs}) => {
                const squadFB = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setSquadFB(squadFB)
                console.log(season, squadFB)
            })
        } catch (error) {
            
        }
    }, [season, teamId])

    function isPlayerAdded(playerId) {
        let isAdded = false;
        const playersFound = squadFB?.filter(
            (player) => player.player_parent_id === playerId
        );
        if (playersFound?.length > 0) {
            isAdded = true;
        }
        return isAdded;
    }

    return (
        <React.Fragment>
            <h4 className="my-4">Legg til spiller i tropp sesong {season}</h4>
        <div className="row">
            {players?.map((player, index) => {

                const playerIsAdded = isPlayerAdded(
                    player.player_parent_id
                );

                return <AddPlayerSquadSeasonListTemplate key={index} player={player} season={season} teamId={teamId} squad={squadFB} playerIsAdded={playerIsAdded} />
            })}
        </div>
        </React.Fragment>

    )
}
